import { computed, Directive, input } from '@angular/core';
import { PurchaseRequestStatus } from '../../../../enums';

interface StatusColors {
  color: string;
  borderColor: string;
  backgroundColor: string;
}

const STATUS_TO_COLOR: Partial<Record<PurchaseRequestStatus, StatusColors>> = {
  [PurchaseRequestStatus.IN_QUOTATION]: {
    color: '#9A6704',
    borderColor: '#FFC107',
    backgroundColor: '#FFFAEB'
  },
  [PurchaseRequestStatus.AWAITING_FOR_APPROVAL]: {
    color: '#3B82F6',
    borderColor: '#3B82F6',
    backgroundColor: '#F1F8FF'
  },
  [PurchaseRequestStatus.PENDING]: {
    color: '#3B82F6',
    borderColor: '#3B82F6',
    backgroundColor: '#F1F8FF'
  },
  [PurchaseRequestStatus.ACCEPTED]: {
    color: '#33A745',
    borderColor: '#33A745',
    backgroundColor: '#EBF8F1'
  },
  [PurchaseRequestStatus.PENDING_INTEGRATION]: {
    color: '#D83C38',
    borderColor: '#D83C38',
    backgroundColor: '#FFF0F0'
  },
  [PurchaseRequestStatus.QUOTED]: {
    color: '#33A745',
    borderColor: '#33A745',
    backgroundColor: '#EBF8F1'
  },
  [PurchaseRequestStatus.URGENT]: {
    color: '#D83C38',
    borderColor: '#D83C38',
    backgroundColor: '#FFF0F0'
  }
};

const FALLBACK: StatusColors = {
  color: '#232325',
  borderColor: '#E0E0EC',
  backgroundColor: '#F7F7FC'
};

/**
 * Cor do chip pelo status. Acompanha o status: quando o mesmo chip passa a mostrar outro status
 * (coluna do quadro reaproveitada, por exemplo), a cor muda junto. Antes a cor era aplicada uma
 * vez só, ao criar o chip, e ficava a do status anterior.
 */
@Directive({
  selector: '[aionzPurchaseStatus]',
  host: {
    '[style.color]': 'colors().color',
    '[style.border-color]': 'colors().borderColor',
    '[style.background-color]': 'colors().backgroundColor'
  }
})
export class PurchaseStatusDirective {
  readonly aionzPurchaseStatus = input<PurchaseRequestStatus | null | undefined>(null);

  protected readonly colors = computed(() => {
    const status = this.aionzPurchaseStatus();
    return (status && STATUS_TO_COLOR[status]) || FALLBACK;
  });
}
